import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    loadChildren: './features/login/login.module#LoginModule'
  },
  {
    path: 'calibration',
    loadChildren: './features/calibration/calibration.module#CalibrationModule'
  },
  {
    path: 'live-stream',
    loadChildren: './features/camera-streaming/camera-streaming.module#CameraStreamingModule'
  },
  {
    path: 'home',
    loadChildren: './features/dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'systemhealth',
    loadChildren: './features/system-health/system-health.module#SystemHealthModule'
  },
  {
    path: 'systemcontrol',
    loadChildren: './features/system-control/system-control.module#SystemControlModule'
  },
  {
    path: 'camera-alignment',
    loadChildren: './features/camera-alignment/camera-alignment.module#CameraAlignmentModule'
  },
  {
    path: 'systeminfo',
    loadChildren: './features/system-info/system-info.module#SystemInfoModule'
  },
  {
    path: 'login',
    loadChildren: './features/login/login.module#LoginModule'
  },
  {
    path: 'dashboard',
    loadChildren: './features/dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'scan-cargo',
    loadChildren: './features/scan-cargo/scan-cargo.module#ScanCargoModule'
  },
  {
    path: 'scan-cargo-guided',
    loadChildren: './features/scan-cargo/scan-cargo.module#ScanCargoModule'
  },
  {
    path: 'scan-history',
    loadChildren: './features/scan-history/scan-history.module#ScanHistoryModule'
  },
  {
    path: 'user-management',
    loadChildren: './features/user-management/user-management.module#UserManagementModule'
  },
  {
    path: 'user-preference',
    loadChildren: './features/user-preference/user-preference.module#UserPreferenceModule'
  },
  {
    path: 'consolidation',
    loadChildren: './features/consolidation/consolidation.module#ConsolidationModule'
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
